// Gramps Lazer Shack - Product Description Accordion
// Splits description on <hr> tags into collapsible sections
// Brooklinen-style: chevron icons, mixed case, first section open

(function() {
  function toMixedCase(str) {
    return str.replace(/\b\w/g, c => c.toUpperCase()).replace(/\bA\b/g, 'a').replace(/\bAn\b/g, 'an').replace(/\bThe\b/g, 'the').replace(/\bOf\b/g, 'of').replace(/\bIn\b/g, 'in').replace(/\bAt\b/g, 'at').replace(/\bFor\b/g, 'for').replace(/\bAnd\b/g, 'and').replace(/\bOr\b/g, 'or');
  }

  function chevronSVG() {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
  }

  function getHeadingFromSection(html) {
    const div = document.createElement('div');
    div.innerHTML = html.trim();
    // Look for <p><strong>...</strong></p> as first element
    const first = div.firstElementChild;
    if (first && first.tagName === 'P') {
      const strong = first.querySelector('strong');
      if (strong && first.textContent.trim() === strong.textContent.trim()) {
        const heading = strong.textContent.trim().replace(/:$/, '');
        div.removeChild(first);
        return { heading: toMixedCase(heading), rest: div.innerHTML };
      }
    }
    return { heading: null, rest: html };
  }

  function initAccordion(container) {
    const raw = container.innerHTML;
    
    // Split on <hr> tags
    const parts = raw.split(/<hr\s*\/?>/i).filter(p => p.trim().length > 0);
    
    let sections = [];
    
    if (parts.length <= 1) {
      // No <hr> found: single accordion "Product Details"
      sections = [{ heading: 'Product Details', content: raw }];
    } else {
      sections = parts.map((part, i) => {
        const { heading, rest } = getHeadingFromSection(part.trim());
        return {
          heading: heading || (i === 0 ? 'About This Product' : 'More Details'),
          content: rest.trim()
        };
      });
    }
    
    // Build accordion HTML
    let html = '';
    sections.forEach((section, index) => {
      const isFirst = index === 0;
      const openClass = isFirst ? ' open' : '';
      html += `
        <div class="glz-accordion-item${openClass}">
          <button class="glz-accordion-btn" aria-expanded="${isFirst}" type="button">
            <span>${section.heading}</span>
            ${chevronSVG()}
          </button>
          <div class="glz-accordion-body">${section.content}</div>
        </div>
      `;
    });
    
    container.innerHTML = html;
    
    // Add click handlers
    container.querySelectorAll('.glz-accordion-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const item = this.closest('.glz-accordion-item');
        const isOpen = item.classList.contains('open');
        item.classList.toggle('open', !isOpen);
        this.setAttribute('aria-expanded', !isOpen);
      });
    });
  }

  function init() {
    document.querySelectorAll('.glz-accordion-description').forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();